import { useEffect, useState } from 'react';
const COOLDOWN_S = 60;
type Props = {
  /** Stuurt dezelfde mail nog eens; geeft een foutmelding terug als het niet lukte. */
  onResend: () => Promise<{
    ok: boolean;
    error?: string;
  }>;
  /** Terug naar het formulier, met het adres nog ingevuld, om een typefout te herstellen. */
  onChangeEmail: () => void;
};

/**
 * Onder "Check je inbox": opnieuw sturen (met een minuut wachttijd, net als VerifyEmailBanner) en
 * een ander adres invullen. Zonder dit was de enige weg terug het hele formulier opnieuw doorlopen.
 */
export function AuthResend({
  onResend,
  onChangeEmail
}: Props) {
  const [wait, setWait] = useState(COOLDOWN_S);
  const [busy, setBusy] = useState(false);
  const [note, setNote] = useState('');
  useEffect(() => {
    if (wait <= 0) return;
    const t = window.setTimeout(() => setWait(w => w - 1), 1000);
    return () => window.clearTimeout(t);
  }, [wait]);
  const resend = async () => {
    setBusy(true);
    setNote('');
    const r = await onResend();
    setBusy(false);
    setNote(r.ok ? 'Verstuurd. Kijk ook even in je spam.' : r.error ?? 'Dat lukte niet. Controleer je verbinding en probeer het opnieuw.');
    if (r.ok) setWait(COOLDOWN_S);
  };
  return <div className="flex flex-col items-start gap-1 text-[14px]" data-id="element-5884" data-mp="ju7ou6t59uew">
      <button type="button" onClick={() => void resend()} disabled={busy || wait > 0} className="inline-flex min-h-[40px] items-center text-ink underline underline-offset-4 transition-colors duration-150 ease-soft hover:text-clay disabled:cursor-default disabled:text-muted disabled:no-underline" data-id="element-5885" data-mp="evwhc2qbnvzu">
        {busy ? 'Versturen…' : wait > 0 ? `Opnieuw sturen kan over ${wait} s` : 'Stuur opnieuw'}
      </button>
      <button type="button" onClick={onChangeEmail} className="inline-flex min-h-[40px] items-center text-ink underline underline-offset-4 transition-colors duration-150 ease-soft hover:text-clay" data-id="element-5886" data-mp="3sc3u72cw6sz3">
        Ander e-mailadres invullen
      </button>
      <p role="status" className="text-[13px] text-muted" data-id="element-5887" data-mp="38or7kpxj8j3r">
        {note}
      </p>
    </div>;
}